import { render } from "./instructor-tickets-modal.vue?vue&type=template&id=19d83be3"
import script from "./instructor-tickets-modal.vue?vue&type=script&lang=js"
export * from "./instructor-tickets-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__